import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { TrendingUp, TrendingDown, Trophy, Target, Activity } from 'lucide-react';

const barColor = (s) => (s >= 80 ? 'bg-emerald-500' : s >= 60 ? 'bg-amber-400' : 'bg-rose-400');

const Metric = ({ label, value, icon: Icon, accent, testId }) => (
  <div className="p-4 rounded-xl bg-white/70 border border-emerald-100" data-testid={testId}>
    <p className="text-xs text-gray-500 flex items-center gap-1"><Icon className="h-3 w-3" />{label}</p>
    <p className={`text-2xl font-bold ${accent || 'text-gray-900'}`}>{value ?? '—'}</p>
  </div>
);

export const ProgressTracker = ({ stats }) => {
  if (!stats || stats.completed_sessions === 0) return null;
  const imp = stats.improvement;
  const impText = imp === null || imp === undefined ? '—' : `${imp > 0 ? '+' : ''}${imp}`;
  const impColor = imp > 0 ? 'text-emerald-600' : imp < 0 ? 'text-rose-600' : 'text-gray-900';
  const ImpIcon = imp < 0 ? TrendingDown : TrendingUp;

  return (
    <Card className="mb-8 border-2 border-emerald-200 bg-gradient-to-br from-white to-teal-50" data-testid="progress-tracker">
      <CardContent className="p-6">
        <h3 className="text-lg font-semibold mb-4 flex items-center gap-2"><Activity className="h-5 w-5 text-emerald-600" />Your Progress</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          <Metric label="Completed" value={stats.completed_sessions} icon={Target} testId="stat-completed" />
          <Metric label="Average score" value={stats.average_score} icon={Activity} testId="stat-average" />
          <Metric label="Best score" value={stats.best_score} icon={Trophy} accent="text-emerald-600" testId="stat-best" />
          <Metric label="Since first session" value={impText} icon={ImpIcon} accent={impColor} testId="stat-improvement" />
        </div>
        {stats.trend?.length > 0 && (
          <div>
            <p className="text-xs text-gray-500 mb-2">Score trend (oldest → newest)</p>
            <div className="flex items-end gap-2 h-28" data-testid="score-trend">
              {stats.trend.map((t, i) => (
                <div key={t.session_id} className="flex-1 flex flex-col items-center justify-end gap-1 group">
                  <span className="text-xs font-semibold text-gray-700">{t.score}</span>
                  <div
                    className={`w-full rounded-t-md ${barColor(t.score)} transition-[height] duration-500`}
                    style={{ height: `${Math.max(4, Math.round(t.score * 0.75))}px` }}
                    title={`${t.score}/100`}
                  />
                  <span className="text-[10px] text-gray-400">#{i + 1}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
